<div class="geocoder">
  <div class="geocoder__header">
    <span class="text_heading-6">{{ title }}</span>

    <div class="actions">
      <button
        tuiIconButton
        type="button"
        [size]="'m'"
        [iconStart]="'@tui.file-plus'"
        [appearance]="'outline-grayscale'"
        [tuiAppearanceMode]="'checked'"
        [tuiHint]="'components.geocoder.buttons.openMultipleInputDialog' | translate"
        (click)="openMultipleInputDialog()"
      ></button>

      <button
        tuiIconButton
        type="button"
        [size]="'m'"
        [iconStart]="'@tui.trash-2'"
        [appearance]="'outline-grayscale'"
        [tuiAppearanceMode]="'checked'"
        [disabled]="!value.length"
        [tuiHint]="'components.geocoder.buttons.deleteAllData' | translate"
        (click)="deleteAllData()"
      ></button>
    </div>
  </div>

  <geocoder-form [(value)]="value"></geocoder-form>
</div>
